import { LoadingScreen } from '../../components/LoadingScreen';
import { useLoginRedirectCallbackPageViewModel } from './useLoginRedirectCallbackPageViewModel';

/**
 * This page is generally where users will first land immediately after logging
 * in via Auth0.
 *
 * It's meant to serve as a temporary loading page while the app's
 * `Auth0Provider` processes the Auth0 response and redirects users to the
 * expected page. Also handles terminal auth errors.
 */
export function LoginRedirectCallbackPageWrapper() {
  useLoginRedirectCallbackPageViewModel();

  // the `Auth0Provider` will handle redirect on successful code exchange
  return <LoadingScreen key='login-callback-loader' />;
}
